import { loadStripe } from "@stripe/stripe-js";

const { REACT_APP_STRIPE_PUB_KEY } = process.env;

const stripePromise = loadStripe(REACT_APP_STRIPE_PUB_KEY || "");

export default stripePromise;
